<template>
  <div class="component-name">
    
  </div>
</template>

<script>
export default {
  name: 'ComponentName',
  components: {
   
  },
  props: {
  
  },
  data() {
    return {
    
    }
  },
  computed: {
   
  },
  watch: {

  },
  created() {
   
  },
  mounted() {

  },
  methods: {
   
  }
}
</script>

<style scoped>

</style>